import { render, staticRenderFns } from "./CustomBrokerageFinalDestination.vue?vue&type=template&id=24f1fb17&scoped=true"
import script from "./CustomBrokerageFinalDestination.vue?vue&type=script&lang=js"
export * from "./CustomBrokerageFinalDestination.vue?vue&type=script&lang=js"
import style0 from "./CustomBrokerageFinalDestination.vue?vue&type=style&index=0&id=24f1fb17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1fb17",
  null
  
)

export default component.exports